export const IMG = (path) => `${process.env.PUBLIC_URL}/img/${path}`;

export const VENUE_IMG =
  'https://images.unsplash.com/photo-1583818776727-148818e8c83f?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format&fit=crop&w=1200';

export const MARQUEE_THEMES = [
  'Multi / Hybrid Clouds',
  'Digital Transformation',
  'Enterprise Security',
  'AI / ML',
  'Data Analytics',
  'CX / ITSM',
  'Remote Working',
  'Hyperautomation',
  'Zero Trust Security',
  'Digital Workflow',
  'Mobile Technology',
  'Internet of Things (IoT)',
  'IT Transformation',
  'Security Operations',
  'DevOps',
  'Platform as a Service',
];

export const STATS = [
  { n: 2, padZero: true, suffix: '', label: 'Largest Cities', note: 'New Delhi · Mumbai' },
  { n: 125, suffix: '+', label: 'Delegates', note: 'Each City' },
  { n: 40, suffix: '+', label: 'Speakers', note: 'Each City' },
  { n: 15, suffix: '+', label: 'Sessions', note: 'Each City' },
  { n: 100, suffix: '+', label: 'CXOs Awards', note: 'Each City' },
];

// Default brand assets (can be overridden from Admin → Site Logos)
export const BRAND_DEFAULTS = {
  logo_header: '/img/brand/cioaxis-logo.png',
  logo_event: '/img/brand/cxo100-event-logo.png',
  logo_footer: '/img/brand/cioaxis-logo.png',
  logo_bottom: '/img/brand/cioaxis-logo.png',
  agenda_visible: '0',
};

export const INDUSTRIES = [
  'Aviation, Logistics, SCM',
  'BFSI, Fintech, NBFC',
  'Manufacturing',
  'Utilities & Power',
  'Healthcare & Pharma',
  'FMCG',
  'PSUs',
  'Retail & Ecommerce',
  'Digital Natives',
  'IT / ITES / GCC',
  'Media, Telecom & Entertainment',
  'Education & EdTech',
];

export const HIGHLIGHTS = [
  { img: 'highlights/Visionary-Keynotes-500x500.jpg', title: 'Visionary Keynotes from Central & State Government and Industry Leaders' },
  { img: 'highlights/Strategic-Panel-Discussions-500x500.jpg', title: 'Strategic Panel Discussions across Sectors' },
  { img: 'highlights/Knowledge-Sessions-500x500.jpg', title: 'Industry-led Knowledge Sessions' },
  { img: 'highlights/CISO-Cyber-Defense-Trailblazer-Awards-500x500.jpg', title: 'CXO Trailblazer Awards' },
  { img: 'highlights/Hall-of-Fame-500x500.jpg', title: 'Cyber Excellence Hall of Fame' },
  { img: 'highlights/Networking-Lounge-500x500.jpg', title: 'Networking Lounge for ITDMs & Solution Providers' },
  { img: 'highlights/Hackathon-Showdown-500x500.jpg', title: 'Exclusive Close Door CXO Roundtables' },
  { img: 'highlights/Hands-On-Workshop-500x500.jpg', title: 'Hands-On Workshop: AI-Driven Threat Detection & Analysis' },
];

export const ATTENDEES = [
  'Chief Information Officers (CIOs)',
  'Chief Information Security Officers (CISOs)',
  'Chief Digital Officers (CDOs)',
  'Chief Technology Officers (CTOs)',
  'Head of AI / ML, Automation, IT, InfoSec',
  'VP, AVP, Director, Head — IT / InfoSec / Engineering',
  'IT, Data, Cloud, Security, AI Architects',
  'Data Scientists & Analysts',
  'GM / AGM / DGM / CGM — IT',
];

export const SEGMENTS = [
  {
    img: 'highlights/Hackathon-Showdown-500x500.jpg',
    tag: '01 / Roundtables',
    title: 'Exclusive Close Door CXO Roundtables',
    desc: 'Compete in a high-stakes ethical hacking challenge designed to test skills and push limits.',
  },
  {
    img: 'highlights/Hands-On-Workshop-500x500.jpg',
    tag: '02 / Workshop',
    title: 'AI-Powered Threat Detection Workshop',
    desc: 'An immersive, expert-led session focusing on real-time threat analysis using AI technologies.',
  },
];

export const WHY_JOIN = [
  'Gain direct access to top CXO industry influencers',
  'Engage with the Top 100+ CXOs of India',
  'Discover emerging trends and policy directions',
  'Network with fellow IT decision-makers and IT leaders',
  'Celebrate excellence at the CXO Trailblazer Awards and Cyber Excellence Hall of Fame',
  'Explore the latest in tech innovation through live demos and exhibits',
  'Exclusive CXO Roundtables',
  'Practical AI / ML Workshops',
];

export const PARTNER_BENEFITS = [
  'Elite Access to top government and CIO networks',
  'Premium Brand Exposure in a highly targeted environment',
  'Qualified Lead Generation through curated engagements',
  'Showcase Opportunities for your latest IT solutions',
  'Influential Relationships that drive business and policy alignment',
];

// Speakers are now dynamically seeded and managed in MySQL database (see /admin -> Speakers)
export const SPEAKERS = [];

// Default sponsors (used only until the Admin → Sponsor Logos table has entries)
export const DEFAULT_SPONSORS = [
  ['Presenting Partner', 'Garnet', 'Garnet.png'],
  ['Powered By Partner', 'TrendAI', 'TrendAI.png'],
  ['Co-Powered By Partner', 'Proofpoint', 'Proofpoint.png'],
  ['Platinum Partner', 'Sophos', 'Sophos-Auxiliary-logos.png'],
  ['Brand Partner', 'Cymmetri', 'Cymmetri.png'],
  ['Enterprise Observability Partner', 'SolarWinds', 'SolarWinds-1.png'],
  ['Gold Partners', 'Barco', 'Barco.png'],
  ['Gold Partners', 'Halofort', 'halofort.png'],
  ['Gold Partners', 'NopalCyber', 'NopalCyber.png'],
  ['Gold Partners', 'Silverfort', 'Silverfort.png'],
  ['Gold Partners', 'Forcepoint', 'Forcepoint-Logo.png'],
  ['Gold Partners', 'Microsoft · Savex', 'Microsoft-Savex.png'],
  ['Silver Partners', 'GoDmarc', 'GoDmarc.png'],
  ['Silver Partners', 'CoreGenX', 'CoreGenX-Logo.png'],
  ['Silver Partners', '42Gears', '42Gears-Logo.png'],
  ['Silver Partners', 'FireCompass', 'FireCompass.png'],
  ['Strategic Compliance Automation Partner', 'SecComply', 'SecComply.png'],
  ['Digital Transformation Partner', 'NeoSoft', 'Neosoft-logo.png'],
  ['Exhibiting Partners', 'Barracuda', 'Barracuda.png'],
  ['Exhibiting Partners', 'Forensic Cybertech', 'Forensic-Cybertech.png'],
  ['Exhibiting Partners', 'Liogard', 'Liogard.png'],
  ['Exhibiting Partners', 'CloudPe', 'CloudPe-Logo-1.png'],
  ['Exhibiting Partners', 'TechPartner', 'TechPartner.png'],
  ['Exhibiting Partners', 'RAC IT', 'RAC-IT.png'],
].map(([tier, name, file], i) => ({ _key: `default-${i}`, tier, name, logo_url: `/img/sponsors/${file}`, website: '' }));

// Group a flat sponsor list into ordered tiers
export const groupSponsors = (list) => {
  const tiers = [];
  const idx = {};
  list.forEach((s) => {
    const t = (s.tier || 'Partners').trim();
    if (idx[t] === undefined) {
      idx[t] = tiers.length;
      tiers.push({ tier: t, items: [] });
    }
    tiers[idx[t]].items.push(s);
  });
  return tiers;
};

// Resolve a stored asset URL (static /img/... path, uploaded /api/files/... path, or absolute URL)
export const assetUrl = (u) => {
  if (!u) return '';
  if (/^https?:\/\//i.test(u) || u.startsWith('data:')) return u;
  const base = process.env.REACT_APP_BACKEND_URL || '';
  if (u.startsWith('/api/')) return `${base}${u}`;
  return `${process.env.PUBLIC_URL || ''}${u.startsWith('/') ? u : `/${u}`}`;
};

export const AWARDS = [
  { a: 'CIO / CTO of the', b: 'Year', id: 'cio-cto' },
  { a: 'CISO of the', b: 'Year', id: 'ciso' },
  { a: 'CDO of the', b: 'Year', id: 'cdo' },
  { a: 'AI Icon of the', b: 'Year', id: 'ai-icon' },
  { a: 'Quantum & DeepTech', b: 'Pioneer', id: 'quantum-deeptech' },
  { a: 'Data Security & Privacy', b: 'Champion', id: 'data-privacy' },
  { a: 'Digital Transformation Team of the', b: 'Year', id: 'dx-team' },
  { a: 'Cybersecurity Team of the', b: 'Year', id: 'cyber-team' },
  { a: 'Enterprise Resilience Team of the', b: 'Year', id: 'resilience-team' },
];

export const CONTACTS = [
  { role: 'Partnership Opportunity', name: 'Jitendra Srivastava', phone: '+91 9818305558', email: 'jeetu@cioaxis.com' },
  { role: 'Speaking Opportunity', name: 'Vikas Singh', phone: '+91 9711911869', email: 'vikas.singh@cioaxis.com' },
  { role: 'Delegate Query', name: 'Ankur Kumar', phone: '+91 9310479166', email: 'ankur.kumar@cioaxis.com' },
];

export const EVENTS = [
  {
    city: 'New Delhi',
    date: 'Feb 05, 2027',
    venue: 'Hotel Radisson Blu Plaza, Delhi Airport',
    address: 'NH-8, Mahipalpur Ex, New Delhi - 110037',
    map: 'https://maps.google.com/?q=Hotel+Radisson+Blu+Plaza+Delhi+Airport+NH-8+Mahipalpur+New+Delhi+110037',
  },
  {
    city: 'Mumbai',
    date: 'Feb 19, 2027',
    venue: 'Hotel Sahara Star',
    address: 'Opposite Domestic Airport, Vile Parle East, Mumbai - 400099',
    map: 'https://maps.google.com/?q=Hotel+Sahara+Star+Opposite+Domestic+Airport+Vile+Parle+East+Mumbai',
  },
];

export const SOCIALS = [
  { name: 'facebook', url: 'https://www.facebook.com/cioaxis' },
  { name: 'twitter', url: 'https://x.com/CIOAXIS/status/1848609069206278580' },
  { name: 'linkedin', url: 'https://www.linkedin.com/showcase/cioaxis' },
];
